import React, { useMemo, useState } from 'react';
import { Menu, theme } from 'antd';
import { useNavigate } from 'react-router-dom';
import menuItem from '../SideMenu.json';

const SidebarMenu = (props) => {
  const navigate = useNavigate();
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleMenuClick = useMemo(
    () =>
      ({ key }) => {
        navigate(key);
      },
    [navigate],
  );

  return <Menu theme={colorBgContainer} mode='inline' items={menuItem} onClick={handleMenuClick} />;
};

export default React.memo(SidebarMenu);
